import { ref, watch } from 'vue';

// 主题状态管理
const isDark = ref<boolean>(false);

// 从 localStorage 读取主题偏好
const loadTheme = () => {
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme) {
    isDark.value = savedTheme === 'dark';
  } else {
    // 检测系统主题偏好
    isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
};

// 保存主题到 localStorage
const saveTheme = (dark: boolean) => {
  localStorage.setItem('theme', dark ? 'dark' : 'light');
};

// 初始化时加载主题
loadTheme();

// 监听主题变化，自动保存
watch(isDark, (newValue) => {
  saveTheme(newValue);
});

export function useTheme() {
  const toggleTheme = () => {
    isDark.value = !isDark.value;
  };

  return {
    isDark,
    toggleTheme
  };
}
